import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-review.scss";
import {IWebsiteBlackReview} from "./types/IWebsiteBlackReview";

export class WebsiteBlackReviewComponent extends Component {
    constructor(review: IWebsiteBlackReview) {
        super();

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBackReview} ${review.tiny ? s.tiny : ``}">
                ${review.title ? `<h2 class="${s.title}">${review.title}</h2>` : ``}
                <div class="${s.content}">
                    <div class="${s.left} ${review.color ? s[review.color] : ``}">
                        <div class="${s.blur}"></div>
                        <div class="${s.icon}"></div>
                    </div>
                    <div class="${s.right}">
                        ${!review.noStars ? `
                    <div class="${s.stars}">
                        <div class="${s.star}"></div>
                        <div class="${s.star}"></div>
                        <div class="${s.star}"></div>
                        <div class="${s.star}"></div>
                        <div class="${s.star}"></div>
                    </div>
                    ` : ``}
                        ${review.review}
                        ${review.linkText ? `
                    <a href="${review.link}" class="${s.link}">
                        ${review.linkText}
                        <div class="${s.icon}"></div>
                    </a>
                    ` : ``}
                        <div class="${s.bottom}">
                            <div class="${s.person}">
                                <div class="${s.name}">
                                    ${review.name}
                                </div>
                                <div class="${s.role}">
                                    ${review.role}
                                </div>
                            </div>
                            ${review.stats ? `
                            <div class="${s.stats}">
                                ${review.stats.map(stat => `
                                <div class="${s.stat}">
                                    <div class="${s.value}">
                                        ${stat.value}
                                    </div>
                                    <div class="${s.label}">
                                        ${stat.label}
                                    </div>
                                </div>
                                `).join("")}
                            </div>
                        ` : ``}
                        </div>
                    </div>
                </div>
            </div>`;
    }
}